import countriesData from "../assets/countries.json";

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatDate = (date: string | Date): string => {
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatAmount = (amount: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};

export const formatNumber = (number: number): string => {
  return Intl.NumberFormat("en-us").format(number);
};

export function transformCountriesForMap(
  countriesDistribution: Record<string, number>
) {
  const dots = [];

  for (const [countryCode, affiliateCount] of Object.entries(
    countriesDistribution
  )) {
    // Find country data in countries.json
    const countryInfo = countriesData.find(
      (country) => country.code === countryCode.toUpperCase()
    );

    if (countryInfo?.geo) {
      // Create a dot for this country
      dots.push({
        start: {
          lat: countryInfo.geo.latitude,
          lng: countryInfo.geo.longitude,
          label: countryInfo.name,
          affiliateCount: affiliateCount,
        },
        end: {
          lat: countryInfo.geo.latitude,
          lng: countryInfo.geo.longitude,
          label: countryInfo.name,
          affiliateCount: affiliateCount,
        },
      });
    }
  }

  return dots;
}

export const getISOCodeFromCountryName = (countryName: string) => {
  const country = countriesData.find((country) => country.name === countryName);
  console.log(country?.code);
  return country?.code;
};



export function formatstorageUrl(url: string) {
  if (!url) return "";

  // 1. Check if it's a Supabase storage URL
  if (!url.includes("/storage/v1/object/public/")) {
    return url;
  }

  // 2. Handle SVGs (They are vectors and shouldn't be processed by the raster engine)
  // We check the path before any existing query parameters
  const pathOnly = url.split('?')[0].toLowerCase();
  if (pathOnly.endsWith(".svg")) {
    return url; 
  }

  // 3. Swap 'object' for 'render/image'
  // We also split by '?' to strip any existing query params that cause 400 errors
  const baseUrl = url.split('?')[0];
  const transformedBase = baseUrl.replace(
    "/storage/v1/object/public/", 
    "/storage/v1/render/image/public/"
  );

  console.log(transformedBase);  
  return `${transformedBase}`;
}

/** 1.2M / 45k style counts for tight cells and tooltips (views, followers). */
export const formatCompactCount = (value: number): string => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  return formatNumber(value);
};
